module.exports = __webpack_public_path__ + "static/media/witryna_01_B.3fe73b81.png";